import React, { useState } from "react";
import "../../../styles/archive_recommendation/retired_favorite.css";

const RetiredFavorite = () => {
  const [favorited, setFavorited] = useState(false);

  const updateFavorited = () => setFavorited(!favorited);

  const emptyHeart = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-heart"
      viewBox="0 0 16 16"
    >
      {" "}
      <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z" />{" "}
    </svg>
  );

  const filledHeart = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-suit-heart-fill"
      viewBox="0 0 16 16"
      id="IconChangeColor"
    >
      {" "}
      <path
        d="M4 1c2.21 0 4 1.755 4 3.92C8 2.755 9.79 1 12 1s4 1.755 4 3.92c0 3.263-3.234 4.414-7.608 9.608a.513.513 0 0 1-.784 0C3.234 9.334 0 8.183 0 4.92 0 2.755 1.79 1 4 1z"
        id="mainIconPathAttribute"
      ></path>{" "}
    </svg>
  );

  return (
    <div className="retired-favorite-container">
      <div>Want to bring this style back? Hit the like button!</div>
      <button onClick={updateFavorited} className="retired-like-button">
        {favorited ? filledHeart : emptyHeart}
      </button>
    </div>
  );
};

export default RetiredFavorite;
